/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CompanySettingFieldItem,
  CompanySettingFieldItemFromJSON,
  CompanySettingFieldItemFromJSONTyped,
  CompanySettingFieldItemToJSON
} from './CompanySettingFieldItem'
import {
  CompanySettingFieldValue,
  CompanySettingFieldValueFromJSON,
  CompanySettingFieldValueFromJSONTyped,
  CompanySettingFieldValueToJSON
} from './CompanySettingFieldValue'

/**
 *
 * @export
 * @interface CompanySettingField
 */
export interface CompanySettingField {
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  label?: string
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  kind?: string
  /**
   *
   * @type {boolean}
   * @memberof CompanySettingField
   */
  isRequired?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CompanySettingField
   */
  isInputRequired?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CompanySettingField
   */
  isInputRequiredOnUser?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CompanySettingField
   */
  isInputRequiredOnEu?: boolean
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  fieldValidate?: string | null
  /**
   *
   * @type {number}
   * @memberof CompanySettingField
   */
  sort?: number
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  itemType?: string | null
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  itemUrl?: string | null
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  placeholder?: string | null
  /**
   *
   * @type {boolean}
   * @memberof CompanySettingField
   */
  isHideOnUser?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CompanySettingField
   */
  isHideOnEu?: boolean
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof CompanySettingField
   */
  updatedAt?: string
  /**
   *
   * @type {Array<CompanySettingFieldValue>}
   * @memberof CompanySettingField
   */
  companySettingFieldValues?: Array<CompanySettingFieldValue>
  /**
   *
   * @type {Array<CompanySettingFieldItem>}
   * @memberof CompanySettingField
   */
  companySettingFieldItems?: Array<CompanySettingFieldItem>
}

export function CompanySettingFieldFromJSON(json: any): CompanySettingField {
  return CompanySettingFieldFromJSONTyped(json, false)
}

export function CompanySettingFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySettingField {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    label: !exists(json, 'label') ? undefined : json['label'],
    kind: !exists(json, 'kind') ? undefined : json['kind'],
    isRequired: !exists(json, 'is_required') ? undefined : json['is_required'],
    isInputRequired: !exists(json, 'is_input_required') ? undefined : json['is_input_required'],
    isInputRequiredOnUser: !exists(json, 'is_input_required_on_user') ? undefined : json['is_input_required_on_user'],
    isInputRequiredOnEu: !exists(json, 'is_input_required_on_eu') ? undefined : json['is_input_required_on_eu'],
    fieldValidate: !exists(json, 'field_validate') ? undefined : json['field_validate'],
    sort: !exists(json, 'sort') ? undefined : json['sort'],
    itemType: !exists(json, 'item_type') ? undefined : json['item_type'],
    itemUrl: !exists(json, 'item_url') ? undefined : json['item_url'],
    placeholder: !exists(json, 'placeholder') ? undefined : json['placeholder'],
    isHideOnUser: !exists(json, 'is_hide_on_user') ? undefined : json['is_hide_on_user'],
    isHideOnEu: !exists(json, 'is_hide_on_eu') ? undefined : json['is_hide_on_eu'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    companySettingFieldValues: !exists(json, 'company_setting_field_values')
      ? undefined
      : (json['company_setting_field_values'] as Array<any>).map(CompanySettingFieldValueFromJSON),
    companySettingFieldItems: !exists(json, 'company_setting_field_items')
      ? undefined
      : (json['company_setting_field_items'] as Array<any>).map(CompanySettingFieldItemFromJSON)
  }
}

export function CompanySettingFieldToJSON(value?: CompanySettingField | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    label: value.label,
    kind: value.kind,
    is_required: value.isRequired,
    is_input_required: value.isInputRequired,
    is_input_required_on_user: value.isInputRequiredOnUser,
    is_input_required_on_eu: value.isInputRequiredOnEu,
    field_validate: value.fieldValidate,
    sort: value.sort,
    item_type: value.itemType,
    item_url: value.itemUrl,
    placeholder: value.placeholder,
    is_hide_on_user: value.isHideOnUser,
    is_hide_on_eu: value.isHideOnEu,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    company_setting_field_values:
      value.companySettingFieldValues === undefined
        ? undefined
        : (value.companySettingFieldValues as Array<any>).map(CompanySettingFieldValueToJSON),
    company_setting_field_items:
      value.companySettingFieldItems === undefined
        ? undefined
        : (value.companySettingFieldItems as Array<any>).map(CompanySettingFieldItemToJSON)
  }
}
